module.exports = __webpack_public_path__ + "img/体测报告icon.81b38389.png";